import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

// Rendered when the user lands on the apex (no broker subdomain detected).
// In MVP scope there's no marketing site yet · this is a friendly placeholder
// that explains the platform and points to the panel login.
export function PublicHomePage() {
  return (
    <div className="flex min-h-screen flex-col">
      <main className="flex flex-1 items-center justify-center px-4 py-16">
        <div className="max-w-xl text-center">
          <img
            src="/nexofacil-icon.png"
            alt="NexoFácil"
            className="mx-auto h-20 w-20"
          />
          <h1 className="mt-6 text-3xl font-bold md:text-4xl">NexoFácil</h1>
          <p className="mt-3 text-lg text-muted-foreground">
            Sistema de qualificação MCMV pra corretores de imóveis.
          </p>
          <p className="mt-6 text-sm text-muted-foreground">
            Cada corretor tem sua página em um subdomínio próprio. Se você é um
            visitante procurando um corretor, peça o link direto a ele.
          </p>
          <div className="mt-8">
            <Button asChild size="lg">
              <Link to="/login">Acessar painel</Link>
            </Button>
          </div>
        </div>
      </main>
      <footer className="border-t py-6 text-center text-xs text-muted-foreground">
        NexoFácil · {new Date().getFullYear()}
      </footer>
    </div>
  );
}
